import React from'react';
import style from "./BotaoNovo.module.css"
import { Link } from "react-router-dom";

function BotaoNovo({link}) {

    return (
        <Link to={link} className={style.botao_novo}>
            + Novo
        </Link>
    );
}
export default BotaoNovo;
